import Axios from 'axios';
import { IServiceState } from '../model/services/types';
import { sessionMiddleware } from './login';

export default class ServiceAPI
{
    // ------- SERVICES ------- //

    static getActiveServices() : Promise<IServiceState[]>
    {
        return Axios.get('./api/services/active')
            .then(sessionMiddleware)
            .then((response: any) => {
                return response.data as IServiceState[];
            });
    }

    static getAllServices() : Promise<{[id: string]: IServiceState[]}>
    {
        return Axios.get('./api/services/list')
            .then(sessionMiddleware)
            .then((response: any) => {
                return response.data as {[id: string]: IServiceState[]};
            });
    }

    static addService(service: string, name: string, params: object) : Promise<IServiceState>
    {
        return Axios.post(`./api/service/${service}/create`, {
            name,
            ...params
        })
            .then(sessionMiddleware)
            .then((response: any) => {
                return response.data as IServiceState;
            });
    }

    static editService(id: string, name: string, params: object) : Promise<IServiceState>
    {
        return Axios.put(`./api/services/${id}`, {
            id,
            name,
            ...params
        })
            .then(sessionMiddleware)
            .then((response: any) => {
                return response.data as IServiceState;
            });
    }

    static removeService(id: string) : Promise<string>
    {
        return Axios.delete(`./api/services/${id}`)
            .then(sessionMiddleware)
            .then((response: any) => {
                return response.data as string;
            });
    }

    // ---------------------- //
}